<template>
	<div>
		<div slot="modal-body">
		<b-row>
			<h5 v-if="message" class="text-danger">Введите правильную цифру!</h5>
			<table class="table table-bordered mt-3" style="margin-right: 10px;margin-left: 10px;">
				<thead>
				<tr>
					<th style="width: 30px;text-align: center">№</th>
					<th>Товар</th>

					<th colspan="2">Количество</th>
					<th style="width: 230px;">Количество</th>
				</tr>
				</thead>
				<tr v-for="lostItem,index in items" :key="lostItem.itemId" cols="12">
					<td style="text-align: center">
						{{ index + 1 }}
					</td>
					<td>{{lostItem.itemName}}/ <strong>{{ lostItem.artikul}}</strong>/{{lostItem.color}}/{{lostItem.size}}
						<strong>{{lostItem.barcode}}</strong></td>

					<td colspan="2">
						{{ lostItem.count }} {{lostItem.unit}}
					</td>
					<td>
						<b-col>
							<b-input-group size="sm">
								<b-form-input v-model="lostItem.qty" @focusout="addItemsToList(lostItem,$event)"
											  size="sm" autocomplete="off" type="number"></b-form-input>
								<b-input-group-addon>
									<b-button size="sm" disabled>
										{{ lostItem.unit }}
									</b-button>
								</b-input-group-addon>
							</b-input-group>
						</b-col>
					</td>
				</tr>
			</table>
			<!--<b-col v-for="lostItem in items" :key="lostItem.itemId" cols="12">-->
				<!--<b-form-group size="sm"-->
							  <!--breakpoint="lg"-->
							  <!--label-size="sm"-->
							  <!--label-cols="4"-->
							  <!--:label="lostItem.itemName	">-->
					<!--<b-row>-->
						<!--<b-col>{{ lostItem.count }} {{lostItem.unit}}</b-col>-->
						<!--<b-col><b-input-group size="sm">-->
							<!--<b-form-input  v-model="lostItem.qty" @focusout="addItemsToList(lostItem,$event)" size="sm" autocomplete="off" type="number"></b-form-input>-->
							<!--<b-input-group-addon>-->
								<!--<b-button size="sm" disabled>-->
									<!--{{ lostItem.unit }}-->
								<!--</b-button>-->
							<!--</b-input-group-addon>-->
						<!--</b-input-group></b-col>-->
					<!--</b-row>-->
				<!--</b-form-group>-->
			<!--</b-col>-->

		</b-row>
		</div>

		<div slot="modal-footer">
			<b-button
				variant="success"
				size="sm"
				class="float-right ml-2"
				@click="submitAdj"
				:disabled="message"
			>
				Сохранить
			</b-button>

			<b-button
				variant="primary"
				size="sm"
				class="float-right"
				@click="cancelAdj"
			>
				Отмена
			</b-button>
		</div>
	</div>
</template>

<script>
	import MaskedInput from 'vue-masked-input'

	export default {
		name: 'Spisat',

		props: {
			documentId: {
				type:Number,
			},
			items: {
				type: Array,
			}
		},

		components: {
			MaskedInput
		},

		data() {
			return {
				item: {
					adjustmentItems: []
				},
				message:false,
			}
		},

		created() {
			this.item.adjustmentItems = this.items;
		},

		methods: {
			addItemsToList(data,$event){


				let foundIndex = null;

				this.item.adjustmentItems.filter(function(adj,index){
					if(adj.whDocumentItemId === data.whDocumentItemId){
						foundIndex = index
					}
				});

				if( $event.target.value !== ''){


					let obj = {
						whDocumentItemId: data.whDocumentItemId,
						qty : $event.target.value
					}

					if(foundIndex !== null){

						this.item.adjustmentItems[foundIndex].qty = $event.target.value
					}else{
						this.item.adjustmentItems.push(obj)
					}



				}else{
					if(foundIndex !== null){
						this.item.adjustmentItems.splice(foundIndex, 1);
					}
				}

			},
			checkValid(){
				let valid = true;
				this.item.adjustmentItems.forEach( item => {
					if(item.count < item.qty || item.qty < 0) {
						valid = false
					}
				});

				if(!valid){
					this.message = true
					return false
				}else{
					this.message = false
					return true

				}
			},
			cancelAdj(){
				this.$emit('cancel');
			},
			submitAdj(){
				this.$emit('ok', this.item.adjustmentItems);

			},
		},

		computed: {

		},
		watch: {
			item: {
				deep: true,
				handler () {
					if(this.checkValid()){
						this.message = false
						this.$emit('input', this.item.adjustmentItems);
					}else{
						this.message = true
					}


				}
			}
		}
	}
</script>

<style scoped>
	.text-danger{
		margin-left: 10px;
	}
</style>
